module.exports = __webpack_public_path__ + "images/b94e7ace761d8c93fceb8b3fa03fb6c8-colorPal.svg";